import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const COUNTDOWN_SECONDS = 15 * 60; // 15:00
const RESET_AFTER_MS = 24 * 60 * 60 * 1000; // 24 hours
const DEADLINE_KEY = 'pr2026_offer_deadline';
const FIRST_VISIT_KEY = 'pr2026_first_visit';
/**
 * Returns the offer deadline (epoch ms). Persists it in localStorage so a page
 * reload keeps counting down from where it was — but resets to a fresh 15:00
 * once 24h have elapsed since the visitor's first visit.
 */
function resolveDeadline(): number {
  const now = Date.now();
  if (typeof window === 'undefined') return now + COUNTDOWN_SECONDS * 1000;
  try {
    const firstVisitRaw = window.localStorage.getItem(FIRST_VISIT_KEY);
    const deadlineRaw = window.localStorage.getItem(DEADLINE_KEY);
    const firstVisit = firstVisitRaw ? parseInt(firstVisitRaw, 10) : NaN;
    const deadline = deadlineRaw ? parseInt(deadlineRaw, 10) : NaN;
    const staleFirstVisit = Number.isNaN(firstVisit) || now - firstVisit > RESET_AFTER_MS;
    // Start a fresh 15:00 window on first ever visit or after the 24h reset.
    if (staleFirstVisit || Number.isNaN(deadline)) {
      const newDeadline = now + COUNTDOWN_SECONDS * 1000;
      window.localStorage.setItem(FIRST_VISIT_KEY, String(now));
      window.localStorage.setItem(DEADLINE_KEY, String(newDeadline));
      return newDeadline;
    }
    // Within the same session/day: resume from the stored deadline.
    return deadline;
  } catch {
    // localStorage unavailable (private mode, etc.) — fall back to a fresh timer.
    return now + COUNTDOWN_SECONDS * 1000;
  }
}
function format(secondsLeft: number): string {
  const clamped = Math.max(0, secondsLeft);
  const mm = String(Math.floor(clamped / 60)).padStart(2, '0');
  const ss = String(clamped % 60).padStart(2, '0');
  return `${mm}:${ss}`;
}
export function StickyAlertBar() {
  const [secondsLeft, setSecondsLeft] = useState<number>(COUNTDOWN_SECONDS);
  useEffect(() => {
    const deadline = resolveDeadline();
    const tick = () => {
      const remaining = Math.round((deadline - Date.now()) / 1000);
      setSecondsLeft(Math.max(0, remaining));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);
  const isExpired = secondsLeft <= 0;
  return <div className="sticky top-0 z-50 w-full border-b-2 border-gold-dark bg-crimson-dark text-white" role="status" aria-live="polite" data-id="element-267">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2 text-center" data-id="element-268">
        {isExpired ? <p className="text-xs font-700 uppercase leading-tight tracking-wide sm:text-sm" data-id="element-269">
            Oferta cerrada por ahora
          </p> : <motion.p animate={{
        opacity: [1, 0.55, 1]
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-xs font-700 uppercase leading-tight tracking-wide sm:text-sm" data-id="element-270">
            <span aria-hidden="true" data-id="element-271">⚠ </span>OFERTA TERMINA EN{' '}
            <span className="tabular-nums" data-id="element-272">{format(secondsLeft)}</span> —
            Después el precio sube a $432.990
          </motion.p>}
      </div>
    </div>;
}